import {  useNavigate } from "react-router";
import { TokenPairIcon } from "../../components/ui/token-pairIcon.tsx";
import { Button } from "../../components/ui/button.tsx";
import { ManageLiquidityPool } from "./components/manage-liquidity-pool.tsx";
import { SelectToken } from "./components/select-token.tsx";
import { TokenIcon } from "../../components/ui/token-icon.tsx";
import { Input } from "../../components/ui/input.tsx";
import { TradeSetting } from "./components/trade-setting.tsx";
import LPTokenSelectInput from "../../components/LPTokenSelectInput";
import { useTranslation } from "react-i18next";
import useDerivedLiquidity from "../../hooks/useDerivedLiquidity.js";
import { useAccount } from "wagmi";
import { useEffect, useState } from "react";
import AccordionList from "../../components/AccordionList/index.js";

  
export default function ImportLiquidityPool() {
  const { t } = useTranslation()
   const {address, chainId} = useAccount()

  const {
      swapMode,
      router,
      inputTokenAllowance,
      inputTokenApprove,
      inputTokenApproving,
      isNoLiquidity,
      swapMistake,
      networkFee,
      inputCurrency,
      onSelectInputCurrency,
      inputCurrencyBalance,
      outputCurrency,
      onSelectOutputCurrency,
      outputCurrencyBalance,
      amountIn,
      amountOut,
      setAmountIn,
      setAmountOut,
      onSwitchCurrency,
      estimating,
      amounts,
      path,
      gasPrice,
      gasLimit,
      outputReserve,
      isPairInLps,
      onImportLiquidityPool,
      loading,
    } = useDerivedLiquidity()
  const navigate = useNavigate();
  return (
    <div className="px-[24px]">
      <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] mb-[15px] rounded-lg">
        <div className="flex items-center justify-between mb-[10px]">
          <Button
            variant={"link"}
            className="!bg-[transparent] p-0 cursor-pointer"
            onClick={() => {
              navigate("/trade", { replace: true });
            }}
          >
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Button>
          {/* <Link to="/trade" className="text-[12px] font-bold">
            <img src="/assets/icons/back.png" alt="" width={12} height={12} />
          </Link> */}
          <span className="text-[12px] font-bold">导入流动池</span>
          <span className="w-[12px] "></span>
        </div>
        <div className="w-full py-[12px] rounded-lg text-[10px] font-regular bg-[#886C24] text-center mb-[12px]">
          提示: 使用此工具可查找未自动出现在界面中的流动池。
        </div>
        <div className="flex flex-col gap-y-[8px] items-center">
          <LPTokenSelectInput
            selectedCurrency={inputCurrency}
            onSelect={onSelectInputCurrency}
            currencyBalance={inputCurrencyBalance}
            amount={amountIn}
            onAmountChange={setAmountIn}
            disabled={true}
            networkFee={networkFee}
          />
          <span>+</span>
          <LPTokenSelectInput
            selectedCurrency={outputCurrency}
            onSelect={onSelectOutputCurrency}
            currencyBalance={outputCurrencyBalance}
            disabled={true}
            amount={amountOut}
          />
        </div>
        {isPairInLps ?(
        <div className="text-[10px] font-regular my-[15px] text-center">
          已添加流动池
        </div>):(
            <Button className="mt-3 w-full disabled:bg-gray-400 bg-button text-black font-medium rounded-lg" onClick={()=>{
              onImportLiquidityPool().finally(()=>{
                navigate("/liquidity");
              })

            }} disabled={loading} >
              导入流动池
            </Button>
        )}
        {/* <ManageLiquidityPool>
          <div className="text-[10px] font-bold text-[#F6A702] text-center">
            管理此流动池
          </div>
        </ManageLiquidityPool> */}
      </div>
      {/* <div className="bg-[#1A1C1E] text-white px-[20px] py-[15px] rounded-lg">
        <div className="text-[10px] font-regular mb-[15px]">
          您的流动资金仓位
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <TokenPairIcon tokens={["BNB", "USDT"]} className="mr-[10px]" />
            <span className="text-[10px] font-regular">/</span>
          </div>
          <span className="text-[10px] font-regular">0</span>
        </div>
        <div className="space-y-[13px] mt-[22px]">
          <div className="text-[10px] font-regular flex justify-between">
            <span>您的流动池份额:</span>
            <span>0.000597</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>:</span>
            <span>NAN</span>
          </div>
          <div className="text-[10px] font-regular flex justify-between">
            <span>:</span>
            <span>NAN</span>
          </div>
        </div>
      </div> */}
              {/* {AccordionList()} */}
      
    </div>
  );
}
